import { create } from 'zustand';

import { FIELD_NAMES_TO_ORDER, ORDER_TYPE, OrderBy, PaginationParams } from '@/features/folders/types';

type UseFoldersTableOrderAndPaginationState = {
  total: number;
  order: OrderBy;
  pagination: PaginationParams;
  updateTotal: (newTotal: number) => void;
  updateOrderBy: (newOrder: OrderBy) => void;
  updatePagination: (newPagination: PaginationParams) => void;
};

export const useFoldersTableOrderAndPaginationState = create<UseFoldersTableOrderAndPaginationState>((set) => ({
  total: 0,
  pagination: { page: 1, pageSize: 10 },
  order: { by: FIELD_NAMES_TO_ORDER.CROSSING_DATE, type: ORDER_TYPE.DESC },
  updatePagination: (newPagination: PaginationParams) => set(() => ({ pagination: newPagination })),
  updateOrderBy: (newOrder: OrderBy) => set(() => ({ order: newOrder })),
  updateTotal: (newTotal: number) => set(() => ({ total: newTotal })),
}));
